import api from 'static/js/app/base/api';
import events from 'static/js/app/base/events';

export default function (cb) {
  api.ssoLogin()
  .then((res) => app.candidate.loginAndGoHome(res))
  .catch((e) => events.fire.navigate('index.html'));
};
